import React, { useEffect, useRef, useState } from "react";
import { Page, CardContainer, } from "../../components";
import { NavTabs } from "../Pos/components-pos/NavSections";
import IconExamples from "./IconExamples";
import ButtonExamples from "./ButtonExamples";
import TextExamples from "./TextExamples";
import FormExamples from "./FormExamples";
import AlarmSound from "./AlarmSound";
import CustomDropdownTest from "./customDD/CustomDropdownTest";
import CalendarTest from "./CalendarTest";
import LzStringTest from "./LzStringTest";
import { gStyle as styles, colors } from "../../components";

export default function UiViewTest(props) {
  useEffect(() => {
    // document.body.requestFullscreen();
  }, [])

  const myStyle = {
    padding: "40px",
    title: {
      ...styles.title,
      ...styles.bold,
      color: colors.primary,
      textAlign: "center",
      fontSize: "40px"
    },
  }

  return (
    <Page>
      <h1 style={myStyle.title}>UI Components</h1>
      <hr />
      <NavTabs {...props} size="120px">
        <IconExamples name="Icons" />
        <ButtonExamples name="Buttons" />
        <TextExamples name="Texts"/>
        <FormExamples name="Forms"/>
        <AlarmSound name="Alarm"/>
        <CustomDropdownTest name="Custom Drop Down"/>
        <CalendarTest name="Calendar"/>
        <LzStringTest name="LzString"/>
      </NavTabs>
    </Page>
  )
}
